<template>
    <div id="ctWrap" >
        <div class="spacer-50 pc-mode"></div>
        <div class="spacer-40 mb-mode"></div>
        <div class="login-top-box">
            <a href="" class="btn-logo"><img src="/img/common/logo.png"></a>
        </div>
        <div class="spacer-20 mb-mode"></div>
        <div class="login-middle-box">
            <p>Name</p>
            <input type="text" name="loginName" id="loginName" class="form-control" v-model="loginName">
            <div class="spacer-20"></div>
            <p>E-Mail Address (Please type in the upper and lower case letters correctly)</p>
            <input type="text" name="loginEmail" id="loginEmail" class="form-control" v-model="loginEmail">
            <div class="spacer-20"></div>
            <p>Password (Please type in the upper and lower case letters correctly)</p>
            <input type="password" name="loginPassword" id="loginPassword" class="form-control rpx-input-box" v-model="loginPassword">
            <div class="spacer-20"></div>
            <p>Confirm Password (Please type in the upper and lower case letters correctly)</p>
            <input type="password" name="loginPasswordConfirm" id="loginPasswordConfirm" class="form-control rpx-input-box" v-model="loginPasswordConfirm">
            <div class="spacer-20"></div>
            <p>Referral(Email)</p>
            <input type="text" name="referral" id="referral" class="form-control rpx-input-box" v-model="referralEmail">
            <div class="spacer-20"></div>
            <p>Center Code</p>
            <input type="text" name="centerCoded" id="centerCoded" class="form-control rpx-input-box" v-model="centerCode" @input="validateCenterCode"
                   maxlength="4"
                   placeholder="0000">
            <div class="spacer-40"></div>
            <div class="m-btn">
                <a href="#" onclick="javascript:return false;" v-on:click="register">Register</a>
            </div>
        </div>
        <!-- Modals -->
        <div class="row">
            <modal :show.sync="modals.notificationShow"
                   gradient="danger"
                   modal-classes="modal-danger modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4">{{ notificationMessage }}</h4>
                </div>

                <template slot="footer">
                    <!--<base-button type="white">Ok, Got it</base-button>-->
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="modals.notificationShow = false">
                        Close
                    </base-button>
                </template>
            </modal>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Modal from "@/components/Modal.vue";
import {eventBus} from "@/main.js";
export default {
    components: {
        Modal
    },
    data: () =>{
        return {
            modals: {
                notificationShow: false,
            },
            notificationMessage : '',
            loginName: '',
            loginEmail: '',
            loginPassword: '',
            loginPasswordConfirm: '',
            referralEmail : '',
            centerCode : ''
        }
    },
    created() {

    },
    mounted() {
        $("#app").removeClass('main');
        $("#gnb").hide(); // 메인의 메인링크부분을 숨긴다.

        console.log("register-share-key=" + this.$store.getters.getReferShareKey);
        console.log("register-center-code=" + this.$store.getters.getReferCenterCode);
        let referCenterCode = this.$store.getters.getReferCenterCode;
        if (referCenterCode) {
            this.centerCode =  referCenterCode;
        }
        if (this.$store.getters.getReferShareKey) {
            const sharekey = this.$store.getters.getReferShareKey;
            axios
                .get("/account/v1/email/" + sharekey)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.status === 's') {
                            this.referralEmail = response.data.email;
                        } else {
                            // 존재하지 않는 레퍼럴이다.
                            this.referralEmail = '';
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                });
        }
    },
    methods:{
        validateCenterCode() {
            // 4자리로 제한
            this.centerCode = this.centerCode.slice(0, 4);
        },
        register:function(){
            console.log("register-share-key=" + this.$store.getters.getReferShareKey);
            if (!this.loginName) {
                this.notificationMessage = "Please, Input Login-Name";
                this.modals.notificationShow = true;
                return;
            }
            if (!this.loginEmail) {
                this.notificationMessage = "Please, Input Email-Address";
                this.modals.notificationShow = true;
                return;
            }
            if (!this.loginPassword) {
                this.notificationMessage = "Please, Input Login-Password";
                this.modals.notificationShow = true;
                return;
            }
            if (!this.loginPasswordConfirm) {
                this.notificationMessage = "Please, Input Confirm-Password";
                this.modals.notificationShow = true;
                return;
            }
            if (this.loginPassword != this.loginPasswordConfirm) {
                this.notificationMessage = "Please, Check Your Confirm-Password";
                this.modals.notificationShow = true;
                return;
            }
            if (!this.centerCode) {
                this.centerCode = '0000';
            }
            this.$store
                .dispatch("register", {
                    name: this.loginName,
                    email: this.loginEmail,
                    password: this.loginPassword,
                    referral_email: this.referralEmail,
                    center_code: this.centerCode,
                    sharekey : this.$store.getters.getReferShareKey,
                })
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.status == 'f') {
                            this.notificationMessage = response.data.message;
                            this.modals.notificationShow = true;
                            return;
                        }
                        this.$router.push('/');
                    }
                })
                .catch(({ message }) => {
                        this.notificationMessage = message;
                        this.modals.notificationShow = true;
                    }
                )
        }
    }
};
</script>
<style>
</style>
